type LocalizedObject<T> = Record<string, T>;

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export const useLocaleValue = () => {
  const { locale } = useI18n();

  const localized = <T = unknown>(value: unknown, localeOverride?: string): T => {
    const localeKey = localeOverride || locale.value;

    if (!isPlainObject(value)) {
      return value as T;
    }

    if (Object.prototype.hasOwnProperty.call(value, localeKey)) {
      return (value as LocalizedObject<T>)[localeKey];
    }

    return value as T;
  };

  return {
    locale,
    localized,
  };
};
